import styled from "styled-components";
import { FONT_SIZE, BUTTON_HEIGHT } from "@lhd/constants";
import { DISPLAY_SIZES } from "@lhd/types";

export const Styles = styled.div<{ $width?: number; $displaySize?: string }>`
  background-color: #fff;
  width: ${(props) => (props.$width ? `${props.$width}px` : "auto")};

  .filter-wrapper {
    .title,
    .input-filter,
    .checkbox-label,
    .action p,
    .footer .btn,
    .ant-radio-wrapper span {
      font-size: ${({ $displaySize }) =>
        FONT_SIZE[
          ($displaySize || DISPLAY_SIZES.SMALL) as keyof typeof FONT_SIZE
        ]} !important;
    }

    .ant-checkbox + span {
      font-size: ${({ $displaySize }) =>
        FONT_SIZE[
          ($displaySize || DISPLAY_SIZES.SMALL) as keyof typeof FONT_SIZE
        ]} !important;
    }

    .ant-btn {
      height: ${({ $displaySize }) =>
        BUTTON_HEIGHT[
          ($displaySize || DISPLAY_SIZES.SMALL) as keyof typeof BUTTON_HEIGHT
        ]} !important;
    }
  }
`;
